import { SearchAggregationsSchema, type SearchAggregations } from '@/domain/documents/schemas';

// Zod boundary for the `aggregations` block on the tile `search_new` response (grid uses the
// dedicated documents/aggregations endpoint via TanStack — see da-19295 D9). Optional: returns
// undefined when absent (responses may omit it) or malformed (degrade gracefully — no tabs/counters
// rather than crash the list).
export const parseSearchAggregations = (raw: unknown): SearchAggregations | undefined => {
  if (raw == null || typeof raw !== 'object') return undefined;
  // tabs/subtypes ride the response top-level. A tab-ineligible category (e.g. Done)
  // sends them as null — a clean "no tabs here", not a malformed block.
  const { tabs, subtypes } = raw as { tabs?: unknown; subtypes?: unknown };
  if (tabs == null && subtypes == null) return undefined;
  const parsed = SearchAggregationsSchema.safeParse({ tabs, subtypes });
  if (parsed.success) return parsed.data;
  console.error('[categorization] invalid aggregations block', parsed.error.issues);
  return undefined;
};
